<template>
  <div class="ribbon-social-wrapper w-100" dir="rtl">

    <a
      v-for="(item, i) in displayedMedias"
      :key="i"
      class="ribbon-row"
      @click="handleClick(item)"
    >
      <div class="icon-badge" :style="{ backgroundColor: item.config.color }">
        <div class="icon-inner-dashed">
          <svg-base :view-box="item.config.viewBox">
              <component :is="item.config.svg" class="social-svg" :style="{ fill: 'white' }"/>
          </svg-base>
        </div>
      </div>

      <div class="ribbon-bar" :style="{ backgroundColor: item.config.color }">
        <span class="link-text" dir="ltr">
          {{ formatUrl(item) }}
        </span>
      </div>
    </a>

    <!-- دکمه نمایش بیشتر / کمتر -->
    <div v-if="enhancedMedias.length > initialLimit" class="toggle-container w-100 mt-2">
      <div class="divider-line"></div>
      <button class="toggle-btn glass-effect" @click="isListExpanded = !isListExpanded">
        <v-icon small color="white" class="mr-1">
          {{ isListExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
        </v-icon>
        <span>{{ isListExpanded ? 'نمایش کمتر' : 'نمایش بیشتر' }}</span>
      </button>
      <div class="divider-line"></div>
    </div>

  </div>
</template>

<script>
const socialConfig = {
  aparat: { svg: "svgAparat", color: "#F986AC", viewBox: 40 },
  eitaa: { svg: "svgEitaa", color: "#F3BF88", viewBox: 50 },
  soroush: { svg: "svgSoroush", color: "#44D3FF", viewBox: 50 },
  bale: { svg: "svgBale", color: "#6EB7FF", viewBox: 50 },
  rubika: { svg: "svgRubika", color: "#C7C7C7", viewBox: 50 },
  gap: { svg: "svgGap", color: "#8D5DFF", viewBox: 40 },
  instagram: { svg: "svgInstagram", color: "#FF51D0", viewBox: 50 },
  whatsapp: { svg: "svgWhatsapp", color: "#58FF6E", viewBox: 50 },
  linkedin: { svg: "svgLinkedin", color: "#4FC1FF", viewBox: 50 },
  linkedin_company: { svg: "svgLinkedinCo", color: "#39BAFF", viewBox: 50 },
  telegram: { svg: "svgTelegram", color: "#45C4FF", viewBox: 50 },
  pinterest: { svg: "svgPinterest", color: "#FC526B", viewBox: 50 },
  dribbble: { svg: "svgDribbble", color: "#FF5C95", viewBox: 50 },
  facebook: { svg: "svgFacebook", color: "#4489FF", viewBox: 50 },
  github: { svg: "svgGithub", color: "#7C7575", viewBox: 32 },
  threads: { svg: "svgThreads", color: "#000", viewBox: 42 },
  tiktok: { svg: "svgTiktok", color: "#A7A7A7", viewBox: 50 },
  twitter: { svg: "svgTwitter", color: "#44C1FB", viewBox: 50 },
  skype: { svg: "svgSkype", color: "#40C1FD", viewBox: 40 },
  youtube: { svg: "svgYoutube", color: "#FA6868", viewBox: 40 },
  wechat: { svg: "svgWechat", color: "#B8FF68", viewBox: 40 },
  viber: { svg: "svgViber", color: "#A977FF", viewBox: 40 },
  divar: { svg: "svgDivar", color: "#F47575", viewBox: "0 0 40 24.33" },
  sheypoor: { svg: "svgSheypour", color: "#459BFC", viewBox: 40 },  
  digikala: { svg: "svgDigikala", color: "#FE7F8D", viewBox: "0.00 0.00 1080.00 1080.00" },
  torob: { svg: "svgTorob", color: "#FB8A8A", viewBox: "0.00 0.00 130.00 130.00" },
  email: { svg: "svgEmail", color: "#3BA7FF", viewBox: 50 },
  address: { svg: "svgLocation", color: "#B8DCF9", viewBox: 50 },
  snappshop: { svg: "svgSnappshop", color: "#FF35F8", viewBox: "0 0 69 40" },
  technolife: { svg: "svgTechnolife", color: "#629DFB", viewBox: "0 0 112 42" },
  emalls: { svg: "svgEmalls", color: "#FCB2AD", viewBox: "0.00 0.00 300.00 78.00" },
  cafebazaar: { svg: "svgCafebazaar", color: "#A7FF93", viewBox: "0.00 0.00 303.00 132.00" },
  googleplay: { svg: "svgGoogleplay", color: "#51AFFC", viewBox: "0 -4.447 361.403 408.86699999999996" },
  samsung: { svg: "svgSamsung", color: "#F9709B", viewBox: "0 0 230 230" },
  apple: { svg: "svgApple", color: "#44A6FC", viewBox: "0 0 512 512" },
  basalam: { svg: "svgBasalam", color: "#F9AD9D", viewBox: "0 0 128 208" }, 
};


import svgFacebook from "../../../../../content/svgLoader/svgFile/svgFacebook";
import svgDribbble from "../../../../../content/svgLoader/svgFile/svgDribbble";
import svgPinterest from "../../../../../content/svgLoader/svgFile/svgPinterest";
import svgTelegram from "../../../../../content/svgLoader/svgFile/svgTelegram";
import svgWhatsapp from "../../../../../content/svgLoader/svgFile/svgWhatsapp";
import svgInstagram from "../../../../../content/svgLoader/svgFile/svgInstagram";
import svgGithub from "../../../../../content/svgLoader/svgFile/svgGithub";
import svgTiktok from "../../../../../content/svgLoader/svgFile/svgTiktok";
import svgEmail from "../../../../../content/svgLoader/svgFile/svgEmail";
import svgLocation from "../../../../../content/svgLoader/svgFile/svgLocation";
import svgEitaa from "../../../../../content/svgLoader/svgFile/pr/svgEitaa";
import svgSoroush from "../../../../../content/svgLoader/svgFile/pr/svgSoroush";
import svgBale from "../../../../../content/svgLoader/svgFile/pr/svgBale";
import svgLinkedin from "../../../../../content/svgLoader/svgFile/svgLinkedin";
import svgLinkedinCo from "../../../../../content/svgLoader/svgFile/svgLinkedinCo.vue";
import svgAparat from "../../../../../content/svgLoader/svgFile/pr/svgAparat";
import svgGap from "../../../../../content/svgLoader/svgFile/pr/svgGap";
import svgDivar from "../../../../../content/svgLoader/svgFile/pr/svgDivar";
import svgSheypour from "../../../../../content/svgLoader/svgFile/pr/svgSheypour";
import svgTwitter from "../../../../../content/svgLoader/svgFile/svgTwitter";
import svgSkype from "../../../../../content/svgLoader/svgFile/svgSkype";
import svgYoutube from "../../../../../content/svgLoader/svgFile/svgYoutube";
import svgWechat from "../../../../../content/svgLoader/svgFile/svgWechat";
import svgViber from "../../../../../content/svgLoader/svgFile/svgViber";
import svgRubika from "../../../../../content/svgLoader/svgFile/pr/svgRubika";
import svgDigikala from "../../../../../content/svgLoader/svgFile/pr/svgDigikala.vue";
import svgBasalam from "../../../../../content/svgLoader/svgFile/pr/svgBasalam.vue"
import svgSnappshop from "../../../../../content/svgLoader/svgFile/pr/svgSnappshop";
import svgTechnolife from "../../../../../content/svgLoader/svgFile/pr/svgTechnolife";
import svgTorob from "../../../../../content/svgLoader/svgFile/pr/svgTorob";
import svgEmalls from "../../../../../content/svgLoader/svgFile/pr/svgEmalls";
import SvgBase from "@/view/content/svgLoader/svgBase";
import svgCafebazaar from "../../../../../content/svgLoader/svgFile/pr/svgCafebazaar.vue";
import svgGoogleplay from "../../../applicaion/cm/svgGoogleplay.vue";
import svgApple from "../../../applicaion/cm/svgAppstore.vue"
import svgSamsung from "../../../applicaion/cm/svgSamsungstore.vue";

export default {
  name: "SocialRibbonList",
  components: {
    SvgBase,
    svgFacebook,
    svgDribbble,
    svgPinterest,
    svgTelegram,
    svgWhatsapp,
    svgInstagram,
    svgGithub,
    svgTiktok,
    svgEmail,
    svgLocation,
    svgEitaa,
    svgSoroush,
    svgBale,
    svgLinkedin,
    svgAparat,
    svgGap,
    svgDivar,
    svgSheypour,
    svgTwitter,
    svgSkype,
    svgYoutube,
    svgWechat,
    svgViber,
    svgRubika,
    svgDigikala,
    svgBasalam,
    svgSnappshop,
    svgTechnolife,
    svgTorob,
    svgEmalls,
    svgCafebazaar, 
    svgGoogleplay, 
    svgApple, 
    svgSamsung,
    svgLinkedinCo
  },
  props: {
    medias: { type: Array, required: true },
    value: { type: Object, required: false },
    getSocialColor: { type: Function, required: false },
  },
  data() {
    return {
      isListExpanded: false,
      initialLimit: 4
    };
  },
  computed: {
    enhancedMedias() {
      return this.medias.map((item) => {
        const key = item.name;
        const config = socialConfig[key] || {
          svg: item.svg,
          color: (this.getSocialColor && this.getSocialColor(key)) || "#888",
          viewBox: 50,
        };
        return {
          ...item,
          config,
        };
      });
    },
    displayedMedias() {
      if (this.isListExpanded) {
        return this.enhancedMedias;
      }
      return this.enhancedMedias.slice(0, this.initialLimit);
    }
  },
  methods: {
    handleClick(item) {
      this.$emit("go-to-url", item.url, item.pattern);
    },
    formatUrl(item) {
      if (item.pattern && item.pattern !== "") {
        return item.pattern + item.url;
      }
      return (item.prefix === "@" ? item.prefix : "www.") + item.url;
    },
  },
};
</script>

<style lang="scss" scoped>
.ribbon-social-wrapper {
  display: flex;
  flex-direction: column;
  gap: 20px; /* فاصله بین ردیف‌های مختلف */
  width: 100%;
  padding: 15px;
  box-sizing: border-box;
}

.ribbon-row {
  display: flex !important;
  flex-direction: row !important; 
  align-items: center !important;
  flex-wrap: nowrap !important; 
  width: 100%;
  position: relative;
  text-decoration: none;
  cursor: pointer;
}

.icon-badge {
  flex-shrink: 0 !important; 
  width: 72px;
  height: 72px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
  box-shadow: -2px 0 10px rgba(0, 0, 0, 0.2);
}

.icon-inner-dashed {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  border: 2px dashed rgba(255, 255, 255, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;

  ::v-deep svg {
    width: 26px;
    height: 26px;
    fill: #ffffff !important;
  }
}

.ribbon-bar {
  flex-grow: 1; 
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: flex-end; 
  position: absolute;
  width: 100%;
  min-width: 100%;
  max-width: 100%;
  
  margin-right: -25px; 
  padding-right: 35px; 
  padding-left: 15px;
  
  border-radius: 0; 
  z-index: 1;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  min-width: 0; 
}

.link-text {
  font-size: 10px;
  color: #ffffff;
  text-transform: uppercase;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 50%;
  text-align: right; 
}

/* استایل‌های مربوط به دکمه نمایش بیشتر/کمتر */
.toggle-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 0 8px;

  .divider-line {
    flex: 1;
    height: 1px;
    background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.4) 50%, rgba(255, 255, 255, 0) 100%);
  }

  .toggle-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    padding: 6px 16px;
    border-radius: 20px;
    font-size: 0.8rem;
    font-weight: 500;
    color: #ffffff;
    background: rgba(255, 255, 255, 0.15);
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

    &:hover {
      background: rgba(255, 255, 255, 0.25);
      transform: translateY(-2px);
    }
    
    span {
      margin-top: 2px;
    }
  }
}

.glass-effect {
  backdrop-filter: blur(12px) !important;
  -webkit-backdrop-filter: blur(12px) !important;
  border: 1px solid rgba(255, 255, 255, 0.2) !important;
}

* {
  font-family: 'Vazirmatn', Tahoma, sans-serif !important;
}
</style>
